import { render, staticRenderFns } from "./addPosts.vue?vue&type=template&id=3aa781bd&scoped=true"
import script from "./addPosts.vue?vue&type=script&lang=js"
export * from "./addPosts.vue?vue&type=script&lang=js"
import style0 from "./addPosts.vue?vue&type=style&index=0&id=3aa781bd&prod&lang=scss&scoped=true"
import style1 from "./addPosts.vue?vue&type=style&index=1&id=3aa781bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa781bd",
  null
  
)

export default component.exports